import type { PushStatus } from 'pwa/helpers/pushNotifications';

/**
 * True when turning push on from a tap can work now: push works here and is
 * off. If the browser already allowed notifications, turning on skips its
 * prompt. Blocked permissions cannot be asked again, and an iPhone can only
 * turn push on from the home screen app, which its status already reports.
 */
export default function canAskForPush(status: PushStatus | null): boolean {
  return status === 'off';
}
